"use strict";

angular.module("customer")
.controller("UserCustomerController", function(
    $scope, $state, $stateParams, $q, FlashBag, StateExtensionService, UserService,
    PartnershipService, GroupService, UserCustomerService
) {
    var _this = this;
    $scope.params = angular.extend({}, $stateParams);
    $scope.pagination = {};

    UserCustomerService.release().then(function onSuccess(user) {
        var deferred = $q.defer();
        if (user && !user.standard_user_customer_count && !!user.global_dedicated_vendor_id) {
            $state.go("partnership-listing", {
                vendorInvite: $stateParams.vendorInvite,
                groupInvite: $scope.groupInvite,
                vendor: $stateParams.vendor,
                catalog: $stateParams.catalog,
                product: $stateParams.product,
                invoice: $stateParams.invoice,
                payment: $stateParams.payment,
                unpaid_invoices: $stateParams.unpaid_invoices
            });
            deferred.reject();
        }
        else {
            deferred.resolve();
        }
        return deferred.promise;
    }).then(function() {
        _this.fetch();
    });

    this.fetch = function() {
        StateExtensionService.updateUrlParams($scope.params);
        UserCustomerService.query($scope.params).$promise
        .then(function onSuccess(data) {
            $scope.pagination = data.pagination;
            $scope.userCustomers = data.results;
            StateExtensionService.updateUrlParams({page: $scope.pagination.current_page});
        });
    };

    this.choose = function(userCustomerId) {
        UserCustomerService.choose(userCustomerId).$promise
        .then(function onSuccess() {
            var updateCurrentNumbers = true;
            UserService.refreshCurrentUser(updateCurrentNumbers).then(function() {
                if ($stateParams.vendor || $stateParams.catalog || $stateParams.product) {
                    $state.go("stocks", {
                        vendorId: $stateParams.vendor,
                        catalog: $stateParams.catalog,
                        product: $stateParams.product
                    });
                }
                else if ($stateParams.vendorInvite) {
                    PartnershipService.add({"vendorInvite": $stateParams.vendorInvite}).then(
                        function success(data) {
                            FlashBag.success(data.detail, true);
                        },
                        function failed(response) {
                            FlashBag.apiError(response, true);
                        }
                    );
                    $state.go("home");
                }
                else if ($stateParams.groupInvite) {
                    GroupService.addCustomerGroupMembershipFromLogin($stateParams.groupInvite);
                }
                else if ($stateParams.invoice) {
                    $state.go("invoiceDetails", {id: $stateParams.invoice});
                }
                else if ($stateParams.payment) {
                    $state.go("paymentDetails", {id: $stateParams.payment});
                }
                else if ($stateParams.unpaid_invoices) {
                    $state.go("payment", {selected: $stateParams.unpaid_invoices});
                }
                else {
                    $state.go("home");
                }
            });
        });
    };

    this.onPageChanged = function() {
        $scope.params = angular.extend($scope.params, {
            page: $scope.pagination.current_page
        });
        this.fetch();
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/user-customer/user-customer-list.controller.js
// module id = 942
// module chunks = 0